import { View, Heading } from "@aws-amplify/ui-react";

const ComingSoonPage = () => {
  return (
    <View padding={15}>
      <svg width="100%" height="200" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#FAFAFA" />
        <text
          x="50%"
          y="40%"
          dominant-baseline="middle"
          text-anchor="middle"
          font-family="Arial"
          font-size="24"
          fill="#333"
        >
          coming soon...
        </text>
        <svg x="47%" y="50%">
        <g>
          <rect x="20" y="0" width="10" height="40" fill="#3498db">
            <animate
              attributeName="y"
              values="0;20;0"
              dur="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="height"
              values="40;20;40"
              dur="1s"
              repeatCount="indefinite"
            />
          </rect>
          <rect x="40" y="0" width="10" height="40" fill="#e74c3c">
            <animate
              attributeName="y"
              values="0;20;0"
              dur="1s"
              repeatCount="indefinite"
              begin="0.2s"
            />
            <animate
              attributeName="height"
              values="40;20;40"
              dur="1s"
              repeatCount="indefinite"
              begin="0.2s"
            />
          </rect>
          <rect x="60" y="0" width="10" height="40" fill="#f1c40f">
            <animate
              attributeName="y"
              values="0;20;0"
              dur="1s"
              repeatCount="indefinite"
              begin="0.4s"
            />
            <animate
              attributeName="height"
              values="40;20;40"
              dur="1s"
              repeatCount="indefinite"
              begin="0.4s"
            />
          </rect>
          <rect x="80" y="0" width="10" height="40" fill="#2ecc71">
            <animate
              attributeName="y"
              values="0;20;0"
              dur="1s"
              repeatCount="indefinite"
              begin="0.6s"
            />
            <animate
              attributeName="height"
              values="40;20;40"
              dur="1s"
              repeatCount="indefinite"
              begin="0.6s"
            />
          </rect>
        </g>
        </svg>

      </svg>
    </View>
  );
};

export default ComingSoonPage;
